module.exports = __webpack_public_path__ + "static/media/H2O_AppIcon.74f12857.png";